import { render } from "./Scheduler.vue?vue&type=template&id=2b4f1591"
import script from "./Scheduler.vue?vue&type=script&lang=js"
export * from "./Scheduler.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__